export default __webpack_public_path__ + "static/media/bitcoinLogo.de49777e.svg";